/**
 * Created by Muiz on 17/10/2017.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import VueCookie from 'vue-cookie'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    auth: {
      token: null,
      userinfo: null
    },
    list_upbjj: {},
    list_tempatuo: {}
  },
  mutations: {
    setToken: (state, value) => {
      state.auth.token = value
      // Vue.localStorage.set('auth.token', value)
      // sessionStorage.setItem('auth.token', value)
      VueCookie.set('auth.token', value)
    },
    setAuth: (state, value) => {
      state.auth.userinfo = value
      // Vue.localStorage.set('auth.userinfo', JSON.stringify(value))
      // sessionStorage.setItem('auth.userinfo', JSON.stringify(value))
      VueCookie.set('auth.userinfo', JSON.stringify(value))
    },
    clearAuth: (state) => {
      state.auth.token = null
      state.auth.userinfo = null
      // Vue.localStorage.remove('auth.token')
      // Vue.localStorage.remove('auth.userinfo')
      // sessionStorage.removeItem('auth.token')
      // sessionStorage.removeItem('auth.userinfo')
      VueCookie.delete('auth.token')
      VueCookie.delete('auth.userinfo')
    }
  },
  actions: {

  },
  getters: {
    getToken: (state) => {
      // var data = Vue.localStorage.get('auth.token')
      // var data = Vue.sessionStorage.getItem('auth.token')
      var data = VueCookie.get('auth.token')
      return data

      /* if (data) {
        state.auth.token = data
        return state.auth.token
      }
      return null */
    },
    getUserInfo: (state) => {
      // var data = Vue.localStorage.get('auth.userinfo')
      // var data = sessionStorage.getItem('auth.userinfo')
      var data = VueCookie.get('auth.userinfo')
      try {
        return JSON.parse(data)
      } catch (e) {
        return {}
      }
      /* if (data) {
        state.auth.userinfo = data
        return state.auth.userinfo
      }
      return null */
    }
  }
})



// WEBPACK FOOTER //
// ./src_suopass/store/index.js